import React, { useState, useEffect } from 'react';

import { motion, AnimatePresence } from 'motion/react';
import { TrendingUp, Star, ArrowRight } from 'lucide-react';
import { ImageWithFallback } from './ImageWithFallback';
import { RestaurantDetailModal } from './RestaurantDetailModal';
import './TrendingRestaurants.css';

function TrendingRestaurants() {
  const [trendingRestaurants, setTrendingRestaurants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedRestaurant, setSelectedRestaurant] = useState(null);

  useEffect(() => {
    fetchTrendingRestaurants();
  }, []);

  const fetchTrendingRestaurants = async () => {
    try {
      setLoading(true);

      // Use mock data that matches the design
      const mockRestaurants = [
        {
          id: '1',
          name: 'Bella Napoli',
          cuisine: 'Italian · Neapolitan',
          priceRange: '$$$',
          address: '342 Bleecker Street, New York, NY 10014',
          phone: '+1 (212) 555-0123',
          hours: '5:00 PM - 10:30 PM',
          rating: 4.8,
          reviews: 342,
          description: 'Experience authentic Neapolitan pizza in the heart of Greenwich Village. Our wood-fired oven creates the perfect crispy yet chewy crust.',
          images: [
            'https://images.unsplash.com/photo-1758648207365-df458d3e83f4?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxyZXN0YXVyYW50JTIwaW50ZXJpb3IlMjBlbGVnYW50JTIwZGluaW5nfGVufDF8fHx8MTc2NDAwMDI4MXww&ixlib=rb-4.1.0&q=80&w=1080',
            'https://images.unsplash.com/photo-1667207394004-acb6aaf4790e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxwaXp6YSUyMG1hcmdoZXJpdGElMjBjbG9zZSUyMHVwfGVufDF8fHx8MTc2NDA5ODA5NHww&ixlib=rb-4.1.0&q=80&w=1080',
            'https://images.unsplash.com/photo-1675965218658-bd6f516742ac?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxyZXN0YXVyYW50JTIwdGFibGUlMjBzZXR0aW5nfGVufDF8fHx8MTc2NDA2NTE3OHww&ixlib=rb-4.1.0&q=80&w=1080',
            'https://images.unsplash.com/photo-1740727665746-cfe80ababc23?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjaGVmJTIwY29va2luZyUyMGtpdGNoZW58ZW58MXx8fHwxNzYzOTkxMjI2fDA&ixlib=rb-4.1.0&q=80&w=1080',
          ],
          specialties: ['Margherita DOC', 'Marinara', 'Diavola', 'Quattro Formaggi', 'Prosciutto e Rucola'],
          trendingScore: 95,
          trendingDishes: [
            {
              name: 'Margherita DOC',
              image: 'https://images.unsplash.com/photo-1667207394004-acb6aaf4790e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxwaXp6YSUyMG1hcmdoZXJpdGElMjBjbG9zZSUyMHVwfGVufDF8fHx8MTc2NDA5ODA5NHww&ixlib=rb-4.1.0&q=80&w=1080',
              votes: 1247,
              trendingRank: 2,
            },
            {
              name: 'Diavola',
              image: 'https://images.unsplash.com/photo-1667207394004-acb6aaf4790e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxwaXp6YSUyMG1hcmdoZXJpdGElMjBjbG9zZSUyMHVwfGVufDF8fHx8MTc2NDA5ODA5NHww&ixlib=rb-4.1.0&q=80&w=1080',
              votes: 986,
              trendingRank: 5,
            },
          ],
          owner: {
            name: 'Giovanni Russo',
            photo: 'https://images.unsplash.com/photo-1759521296047-89338c8e083d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjaGVmJTIwcG9ydHJhaXQlMjBwcm9mZXNzaW9uYWx8ZW58MXx8fHwxNzYzOTg4NTQwfDA&ixlib=rb-4.1.0&q=80&w=1080',
            bio: 'Born and raised in Naples, Giovanni brings three generations of pizza-making tradition to New York City.',
            story: 'I grew up watching my grandfather knead dough in our family pizzeria in Naples.',
            favoritedish: 'Margherita DOC with buffalo mozzarella',
            social: {
              instagram: 'https://instagram.com/bellanapolinyc',
              facebook: 'https://facebook.com/bellanapolinyc',
              website: 'https://bellanapoli.com',
            },
            interview: [
              {
                question: 'What makes Neapolitan pizza special?',
                answer: 'It\'s all about simplicity and quality.',
              },
            ],
          },
        },
        {
          id: '2',
          name: "L'Artisan",
          cuisine: 'Modern Italian · Fine Dining',
          priceRange: '$$$$',
          address: '789 Madison Avenue, New York, NY 10065',
          phone: '+1 (212) 555-0456',
          hours: '6:00 PM - 11:00 PM',
          rating: 4.9,
          reviews: 521,
          description: 'A contemporary take on Italian classics with seasonal ingredients and innovative techniques from our Michelin-starred chef.',
          images: [
            'https://images.unsplash.com/photo-1675965218658-bd6f516742ac?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxyZXN0YXVyYW50JTIwdGFibGUlMjBzZXR0aW5nfGVufDF8fHx8MTc2NDA2NTE3OHww&ixlib=rb-4.1.0&q=80&w=1080',
            'https://images.unsplash.com/photo-1758648207365-df458d3e83f4?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxyZXN0YXVyYW50JTIwaW50ZXJpb3IlMjBlbGVnYW50JTIwZGluaW5nfGVufDF8fHx8MTc2NDAwMDI4MXww&ixlib=rb-4.1.0&q=80&w=1080',
            'https://images.unsplash.com/photo-1667207394004-acb6aaf4790e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxwaXp6YSUyMG1hcmdoZXJpdGElMjBjbG9zZSUyMHVwfGVufDF8fHx8MTc2NDA5ODA5NHww&ixlib=rb-4.1.0&q=80&w=1080',
            'https://images.unsplash.com/photo-1740727665746-cfe80ababc23?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjaGVmJTIwY29va2luZyUyMGtpdGNoZW58ZW58MXx8fHwxNzYzOTkxMjI2fDA&ixlib=rb-4.1.0&q=80&w=1080',
          ],
          specialties: ['Truffle Risotto', 'Osso Buco', 'Handmade Tortellini', 'Branzino al Cartoccio'],
          trendingScore: 98,
          trendingDishes: [
            {
              name: 'Truffle Risotto',
              image: 'https://images.unsplash.com/photo-1749169337822-d875fd6f4c9d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxwYXN0YSUyMGl0YWxpYW4lMjBkaXNofGVufDF8fHx8MTc2Mzk4NzU1OHww&ixlib=rb-4.1.0&q=80&w=1080',
              votes: 1532,
              trendingRank: 1,
            },
            {
              name: 'Handmade Tortellini',
              image: 'https://images.unsplash.com/photo-1749169337822-d875fd6f4c9d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxwYXN0YSUyMGl0YWxpYW4lMjBkaXNofGVufDF8fHx8MTc2Mzk4NzU1OHww&ixlib=rb-4.1.0&q=80&w=1080',
              votes: 1124,
              trendingRank: 3,
            },
            {
              name: 'Osso Buco',
              image: 'https://images.unsplash.com/photo-1675965218658-bd6f516742ac?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxyZXN0YXVyYW50JTIwdGFibGUlMjBzZXR0aW5nfGVufDF8fHx8MTc2NDA2NTE3OHww&ixlib=rb-4.1.0&q=80&w=1080',
              votes: 1089,
              trendingRank: 4,
            },
          ],
        },
      ];

      setTrendingRestaurants(mockRestaurants);
    } catch (error) {
      console.error('Error fetching trending restaurants:', error);
      setTrendingRestaurants([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="py-16">
        <div className="container mx-auto px-8 max-w-7xl">
          <div className="text-center">
            <p className="text-muted-foreground">Loading trending restaurants...</p>
          </div>
        </div>
      </div>
    );
  }

  if (trendingRestaurants.length === 0) {
    return null;
  }

  return (
    <div className="py-16">
      <div className="container mx-auto px-8 max-w-7xl">
        <div className="flex items-center justify-between mb-12">
          <div>
            <div className="w-1 h-16 bg-border mb-6"></div>
            <h2 className="serif text-6xl mb-4">Trending Restaurants</h2>
            <p className="text-sm text-muted-foreground max-w-2xl">
              Hot spots with multiple highly-rated dishes making waves in the community
            </p>
          </div>
          <div className="flex items-center gap-2 bg-red-50 px-4 py-2 border border-red-200">
            <TrendingUp className="w-4 h-4 text-red-600" />
            <span className="text-xs uppercase tracking-widest text-red-600">Live Now</span>
          </div>
        </div>

        <div className="space-y-12">
          {trendingRestaurants.map((restaurant, index) => (
            <motion.article
              key={restaurant.id}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className="border border-border group hover:border-foreground transition-colors cursor-pointer"
              onClick={() => setSelectedRestaurant(restaurant)}
            >
              <div className="block">
                <div className="grid grid-cols-12">
                  {/* Main Restaurant Image */}
                  <div className="col-span-5">
                    <div className="aspect-[4/3] overflow-hidden relative">
                      <ImageWithFallback
                        src={restaurant.images[0] || ''}
                        alt={restaurant.name}
                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                      />
                      <div className="absolute top-6 right-6 bg-background px-4 py-2 border border-border">
                        <div className="flex items-center gap-2">
                          <Star className="w-3.5 h-3.5 fill-current" />
                          <span className="text-xs">{restaurant.rating}</span>
                        </div>
                      </div>
                      {/* Trending Score Badge */}
                      <div className="absolute bottom-6 left-6 bg-foreground text-background px-4 py-2">
                        <p className="text-xs uppercase tracking-widest">Trending Score</p>
                        <p className="serif text-2xl">{restaurant.trendingScore}</p>
                      </div>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="col-span-7 p-10 flex flex-col justify-between">
                    <div>
                      <h3 className="serif text-5xl mb-3 group-hover:text-muted-foreground transition-colors">
                        {restaurant.name}
                      </h3>
                      <p className="text-xs uppercase tracking-widest text-muted-foreground mb-6">
                        {restaurant.cuisine} · {restaurant.priceRange}
                      </p>
                      <p className="text-sm text-muted-foreground leading-relaxed mb-8">
                        {restaurant.description}
                      </p>

                      {/* Trending Dishes */}
                      {restaurant.trendingDishes && restaurant.trendingDishes.length > 0 && (
                        <div className="mb-8">
                          <h4 className="text-xs uppercase tracking-widest mb-4 flex items-center gap-2">
                            <TrendingUp className="w-4 h-4" />
                            <span>Trending Dishes ({restaurant.trendingDishes.length})</span>
                          </h4>
                          <div className="grid grid-cols-3 gap-4">
                            {restaurant.trendingDishes.map((dish) => (
                              <div key={dish.name} className="group/dish">
                                <div className="aspect-square overflow-hidden mb-2 relative">
                                  <ImageWithFallback
                                    src={dish.image}
                                    alt={dish.name}
                                    className="w-full h-full object-cover"
                                  />
                                  <div className="absolute top-2 left-2 w-7 h-7 bg-foreground text-background flex items-center justify-center text-xs">
                                    #{dish.trendingRank}
                                  </div>
                                </div>
                                <p className="text-xs mb-1">{dish.name}</p>
                                <p className="text-xs text-muted-foreground">{dish.votes.toLocaleString()} votes</p>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="flex items-center justify-between pt-6 border-t border-border">
                      <div className="text-xs text-muted-foreground">
                        {restaurant.reviews} reviews · {restaurant.address?.split(',')[1] || restaurant.address}
                      </div>
                      <div className="flex items-center gap-2 text-xs uppercase tracking-widest group-hover:gap-3 transition-all">
                        <span>View Restaurant</span>
                        <ArrowRight className="w-4 h-4" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>

      {/* Restaurant Detail Modal */}
      <AnimatePresence>
        {selectedRestaurant && (
          <RestaurantDetailModal
            restaurant={selectedRestaurant}
            onClose={() => setSelectedRestaurant(null)}
          />
        )}
      </AnimatePresence>
    </div>
  );
}

export default TrendingRestaurants;
